/**
 * URL Helpers
 *
 * Centralized URL generation for guide and org routes.
 */

import {parse} from 'tldts';

/**
 * Build the canonical URL path for a guide landing page.
 */
export function buildGuideUrl(orgSlug: string, guideSlug: string): string {
  return `/o/${orgSlug}/g/${guideSlug}`;
}

/**
 * Derive an org slug from a website URL.
 *
 * Examples:
 *   https://www.seattleschools.org/  → seattleschools-org
 *   school.k12.wa.us                 → school-k12-wa-us
 */
export function domainToSlug(input: string): string {
  const raw = input.trim();
  if (!raw) return '';

  // Ensure there's a protocol so URL parsing works
  const withProto = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;

  let hostname: string;
  try {
    hostname = new URL(withProto).hostname.toLowerCase();
  } catch {
    return '';
  }

  // Strip leading www.
  hostname = hostname.replace(/^www\./, '');

  // Use tldts to identify the public suffix so we can keep full structure
  const parsed = parse(hostname);
  if (!parsed.hostname) return '';

  // Replace dots with hyphens, strip non-alphanumeric/hyphen, collapse hyphens
  return parsed.hostname
    .replace(/\./g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
